import { EventsService } from '@/service/EventsService'
import { reactive } from 'vue'

export class EventsState {
  state = reactive({
    fetching: false,
    events: [] as any[],
    eventsMap: {} as Record<string, any>,
  })

  cache: Record<string, any[]> = {}

  async fetchEvents(startDate: string, endDate: string, forceRefresh = false) {
    const cacheKey = `${startDate}-${endDate}`

    if (!forceRefresh && this.cache[cacheKey]) {
      //return { events: this.cache[cacheKey], fromCache: true }
    }

    try {
      this.state.fetching = true
      const newEventsList = await EventsService.fetchEvents(startDate, endDate)
      this.cache[cacheKey] = newEventsList
      this.state.events = newEventsList // Update the state with new events
      return { events: newEventsList, fromCache: false }
    } catch (error: any) {
      console.error(error)
      throw error
    } finally {
      setTimeout(() => (this.state.fetching = false), 1000)
    }
  }

  async fetchPastAndUpcomingEvents(query: any) {
    const response = await EventsService.fetchPastAndUpcomingEvents(query)
    return response
  }

  async addToCalendar(calendar: string, eventId: string) {
    const response = await EventsService.addEventToCalendar(calendar, eventId)
    return response
  }

  async createEvent(event: any): Promise<any> {
    const response = await EventsService.createEvent(event)
    return response
  }

  async updateEvent(event: any): Promise<any> {
    const response = await EventsService.updateEvent(event)
    return response
  }

  async deleteEvent(eventId: string, query?: any): Promise<any> {
    const response = await EventsService.deleteEvent(eventId, query)
    return response
  }

  async exportAttendees(eventId: string) {
    const response = await EventsService.exportAttendees(eventId)
    return response
  }

  async fetchEventById(eventId: string, query: any): Promise<any> {
    // occurrenceDate is include in cache for cache of recurring event, where a particular occurrence is deleted
    const cacheKey = `${eventId}-${query.occurrenceDate}`
    try {
      if (this.state.eventsMap[cacheKey]) {
        return this.state.eventsMap[cacheKey]
      }
      const response = await EventsService.fetchEventById(eventId, query)

      this.state.eventsMap[cacheKey] = response
      return response
    } catch (error: any) {
      if (error?.response?.status === 404) {
        this.state.eventsMap[cacheKey] = 'deleted'
        return 'deleted'
      } else {
        this.state.eventsMap[cacheKey] = 'not-accessible'
        return 'not-accessible'
      }
    }
  }
}

export const EventState = new EventsState()
